export enum NachrichtAction {
  REPLY,
  EDIT,
  DOWNLOAD,
  RESTORE,
  DELETE,
  DELETE_IRREVOCABLE
}
